module.exports = __webpack_public_path__ + "img/warning.3bae402e.svg";